export default __webpack_public_path__ + "static/media/approved-payment.7fc646af.svg";